// Campus photo for /colleges/university-of-georgia: CC0 1.0, by Coxonian, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUGA_North_Campus.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-georgia/; credited under the photo.
const photo = {
    "slug": "university-of-georgia",
    "alt": "Historic North Campus at the University of Georgia in Athens, Georgia",
    "src": "/colleges/university-of-georgia/campus-1600.webp",
    "srcSmall": "/colleges/university-of-georgia/campus-800.webp",
    "srcMid": "/colleges/university-of-georgia/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-georgia/og.jpg",
    "title": "UGA North Campus",
    "author": "Coxonian",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUGA_North_Campus.jpg",
    "read": "2026-09-30"
};

export default photo;
